import { render, staticRenderFns } from "./orderReturnPop.vue?vue&type=template&id=5b6bf688"
import script from "./orderReturnPop.vue?vue&type=script&lang=js"
export * from "./orderReturnPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports